import { Badge } from 'antd';
import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import {
  OneOfFilterDataGrid,
  StringFilterDataGrid,
} from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/terminals/router/routes';

import { TTerminal } from '../../core/terminal';

export const cols: TEntityGridColumn<TTerminal>[] = [
  {
    field: 'id',
    headerName: 'ID',
    width: 130,
    flex: 1,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminal }) => {
      const path = appRoute.TERMINAL.buildPath({
        id: data.id,
      });

      return <Link to={path}>{data.id}</Link>;
    },
  },
  {
    flex: 3,
    field: 'blocked',
    headerName: 'Статус',
    colId: 'blocked',
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminal }) => {
      return (
        <Badge
          status={data.blocked ? 'error' : 'success'}
          text={data.blocked ? 'Заблокирован' : 'Активен'}
        />
      );
    },
    filter: OneOfFilterDataGrid({
      filterName: 'blocked',
      options: [
        // @ts-expect-error ...
        { label: 'Заблокирован', value: true },
        // @ts-expect-error ...
        { label: 'Активен', value: false },
      ],
    }),
  },
  {
    flex: 3,
    field: 'dsn',
    headerName: 'DSN',
    colId: 'dsn',
    sortable: false,
    comparator: () => 0,
    filter: StringFilterDataGrid({ filterName: 'dsn' }),
  },
  {
    field: 'profile',
    headerName: 'Профиль',
    colId: 'profile',
    flex: 1,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminal }) => {
      if (!data.profile) return;

      const path = appRoute.PROFILE.buildPath({ id: data.profile.id });

      return (
        <Link to={path}>{data.profile.name ?? `ID: ${data.profile.id}`}</Link>
      );
    },
  },
  {
    flex: 3,
    field: 'type',
    headerName: 'Тип',
    colId: 'type',
    sortable: false,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTerminal }) => {
      return data.type.name;
    },
  },
];
